import React from "react";

const TableLoader = () => (
    <>
        {Array.from({ length: 4 }).map((_, rowIdx) => (
            <tr key={rowIdx}>
                <td colSpan="12" style={{ padding: 0 }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "80px",
                        background: "#fff",
                        paddingLeft: "10px",
                        paddingRight: "10px"
                    }}>
                        <div style={{
                            display: "flex",
                            gap: "6px",
                            width: "100%",
                            justifyContent: "center"
                        }}>
                            {Array.from({ length: 6 }).map((_, i) => (
                                <span
                                    key={i}
                                    style={{
                                        flex: 1,
                                        height: "32px",
                                        borderRadius: "8px",
                                        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                        display: "inline-block",
                                        animation: `table-shimmer 1.2s ${i * 0.08}s infinite linear`
                                    }}
                                ></span>
                            ))}
                        </div>
                        <style>
                            {`
                            @keyframes table-shimmer {
                                0% {
                                    background-position: -240px 0;
                                }
                                100% {
                                    background-position: 240px 0;
                                }
                            }
                            `}
                        </style>
                    </div>
                </td>
            </tr>
        ))}
    </>
);

export default TableLoader;
